<template>
    <div class='loginForm'>
        <el-form
            :model="loginForm"
            label-width="100px"
            label-size="20px"
            :rules="loginRules"
            auto-complete="on"
            label-position="right"
            ref="loginForm">
            <div class="loginForm_slogan">
                <span>欢迎使用  ITSM管控平台</span>
            </div>
            <el-form-item label="账号" prop="username">
                <el-input v-model="loginForm.username" placeholder="请输入账号信息"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
                <el-input @keyup.enter.native="submitForm" type="password"  v-model="loginForm.password" placeholder="密码不小于五位"></el-input>
            </el-form-item>
            <!-- <el-form-item class='routerLink'>
                <el-button type='text' @click="handitemclick('register')">注册用户</el-button>
            </el-form-item> -->

<!--            <el-form-item label="验证码" prop="vcode" v-if="ind==1">-->
<!--                <el-input @keyup.enter.native="submitForm"  v-model="loginForm.vcode" style="width:75%;"></el-input>-->

<!--                <el-button style="margin-right:20px;" type='text' @click="getVcodeEvent" :disabled="countFlag">获取验证码</el-button>-->
<!--            </el-form-item>-->
<!--            <el-form-item style="text-align:right;" v-if="countFlag && ind==1">-->
<!--                <span style="color:#ccc;margin-right:5px;">获取验证码({{countdown}}s)</span>-->
<!--            </el-form-item>-->
<!--            <p class="tipText" v-show="ind==1">提示:四维智联员工输入飞书接收到的验证码</p>-->
            <!-- 第三方登录验证 -->
            <div class="thirdTipText">
                <p>※ 请根据图片的内容，计算出最终结果，输入到文本框内</p>
                <p>※ 单击图片更换新图</p>
            </div>
            <el-form-item prop="verification_code" class="codeItem">
                <el-row :gutter="20" style="margin-left:-100px;">
                    <el-col :span="11">
                         <img :src="imgurl" style="width:80%;height:40px;top:0" @click="imgUrlEvent">
                        <!-- </div> -->
                    </el-col>
                    <el-col :span="11">
                        <el-input v-model.number="loginForm.verification_code"></el-input>
                    </el-col>
                </el-row>
            </el-form-item>


            <el-form-item class='routerLink'>
                <!-- <el-button style="float:right;" v-show="ind==1" type="text" @click="wechat_login">企业微信扫码登录</el-button> -->
                <el-button style="margin-right:20px;" type='text' @click="handitemclick('forget')">忘记密码</el-button>
            </el-form-item>
        </el-form>
        <div class='submintbtn'>
            <el-button type="primary" @click="getCryptoJsEvent" :loading="loading">登录</el-button>
            <el-button type="primary" @click='cancel'>取消</el-button>
        </div>
    </div>


</template>

<script>
    import CryptoJS from 'crypto-js'
    import { isvalidUsername } from '../../core/utils/validate'
    import ssoService from '../../services/sso.service.js'
    import Config from "../../app.config";
    const baseURL = Config.ssoServiceUser
    const baseURL1 = Config.ssoService
    export default {
        props: {
            ind: String | Number
        },
        data() {
            const validateUsername = (rule, value, callback) => {
                if (!isvalidUsername(value)) {
                    callback(new Error('请输入正确的用户名'))
                } else {
                    callback()
                }
            };
            const validatePass = (rule, value, callback) => {
                if (value.length < 5) {
                    callback(new Error('密码不能小于5位'))
                } else {
                    callback()
                }
            };
            return {
                formName: "loginForm",
                imgurl:'',
                baseURL,
                baseURL1,
                loginForm: {
                    username: '',
                    password: '',
                    verification_code:null,
                    verification_key:'',
                    vcode:''
                },
                countFlag:false,
                countdown:60,
                loginRules: {
                    username: [
                        {required: true, message: '请输入账号', trigger: 'blur'},
                    ],
                    password: [{required: true, trigger: 'blur', validator: validatePass}],
                    vcode:[{required: true, message: '请输入验证码', trigger: ['blur']}],
                    verification_code: [
                        {required: true, message: '请输入验证码', trigger: ['blur']},
                        { type: 'number', message: '验证码须为数字'}
                    ],
                },
                cryptoPassword:'',
                loading: false,
                timer: null,
                useridTimer:null,
            }

        },
        // watch:{
        //     ind:{
        //         handler:function(newValue,oldValue){
        //             console.log(newValue)
        //         },
        //         deep:true
        //     }
        // },
        mounted() {
            this.imgUrlEvent()
            if(this.ind == 2){
                this.imgUrlEvent()
            }
        },
        methods: {

            getVxcode(){
                ssoService.getVcode({username:this.loginForm.username})
                .then(() => console.log('成功'))
                .catch(err => {
                    this.loading = false;
                    this.$message({message: err.message, type: 'error'});
                })
            },
            settime() {
                if (this.countdown == 0) {
                    this.countdown = 60;
                    this.countFlag = false
                    this.clearTimer()
                } else {
                    this.countFlag = true
                    this.countdown--
                    let _this = this
                    _this.timer = setTimeout(function() {
                        _this.settime()
                    },1000)
                }
            },
            clearTimer(){
                window.clearTimeout(this.timer);
                return false;
            },
            // 四维员工登录验证
            getVcodeEvent(){
                this.settime()
                this.getVxcode()
            },
            randomCoding(){
                var result = [];
                let n = 10;//这个值可以改变的，对应的生成多少个字母，根据自己需求所改
                for(var i=0;i<n;i++){
                    //生成一个0到25的数字
                    var ranNum = Math.ceil(Math.random() * 25);
                    //大写字母'A'的ASCII是65,A~Z的ASCII码就是65 + 0~25;
                    //然后调用String.fromCharCode()传入ASCII值返回相应的字符并push进数组里
                    result.push(String.fromCharCode(65+ranNum));
                }
                return result.join('');
            },
            imgUrlEvent(){
                let str = this.randomCoding()
                this.loginForm.verification_key = str
                if(this.ind == 1){
                    this.imgurl = `${this.baseURL1}usercenter/sso/third/v3/user/verification_code?verification_key=${str}`
                }else if(this.ind == 2){
                    this.imgurl = `${this.baseURL}user/verification_code?verification_key=${str}`
                }
                // this.imgurl = 'http://wedof.beta.autoai.com/usercenter/sso/third/v3/user/verification_code?verification_key='+ str

            },
            wechat_login(){
                this.$emit("wechatLogin")
            },
            getUserRoles(userId){
                let self = this;
                ssoService.UserRoles({app_name:'itsm',user_id: userId}).then((result) => {
                    this.$setRoles(result);
                    let routerLink = window.localStorage.getItem('routerLink') || "/";


                    if (routerLink === "/") {
                        self.$router.push(routerLink);
                    } else {

                        let startNum = routerLink.indexOf("#");
                        let endNum = routerLink.indexOf("?") || 100;
                        let query = {};
                        let path = ""
                        if (endNum != -1) {
                            path = routerLink.substring(startNum + 1, endNum);
                            let queryStr = routerLink.substr(endNum + 1);
                            let queryArr = queryStr.split("&");
                            queryArr.forEach(item => {
                                query[item.split("=")[0]] = item.split("=")[1];
                            })
                        } else {
                            path = routerLink.substring(startNum + 1);
                        }
                        // console.log(path)
                        this.$store.dispatch('getDictionary');   // 获取全部的数据字典
                        this.$store.dispatch('getDictionary2');   // 获取全部的CICD数据字典
                        this.$store.dispatch('getCaseType');     // 所有的类型id
                        //用定时器异步处理保证字典取完后再渲染跳转的路由页面
                        this.timer = setTimeout(() => {
                            self.$router.push({path, query});
                            clearTimeout(self.timer)
                        }, 300)


                    }
                    window.localStorage.removeItem("routerLink");
                    // //在这里动态获取menu试试
                    // console.log('loginForm里dispatch了getMenuData1')
                    // this.$store.dispatch('getMenuData')
                    // this.$setRoles(result);
                    // self.$router.replace('/');
                });
            },
            submitForm() {
                const self = this;
                let formName = this.$data.formName;
                self.loading = true;
                self.$refs[formName].validate((valid) => {
                    // console.log(valid)
                    if (valid) {
                        let vm=this
                        let params
                        if(this.ind == 1){
                            params = {
                                username: this.loginForm.username,
                                password: this.cryptoPassword,
                                verification_code: this.loginForm.verification_code,
                                verification_key: this.loginForm.verification_key
                                // vcode: this.loginForm.vcode
                            }
                        }else{
                            params = {
                                username: this.loginForm.username,
                                password: this.cryptoPassword,
                                verification_code: this.loginForm.verification_code,
                                login_type: 'third',
                                verification_key: this.loginForm.verification_key
                            }
                        }
                        ssoService.login(params).then((data) => {
                            self.loading = false;
                            // console.log(data)
                            this.$cookies.set('token', data.token)
                            for (let i in data.cookie) {
                                this.$cookies.set(i, data.cookie[i])
                            }
                            let params = {
                                user: {
                                    username: data.cookie.user_name,
                                    userid: data.token
                                }
                            }
                            this.$store.commit('setUserInfo', params);
                            this.useridTimer = setTimeout(function(){
                                if(this.$cookies.get('user_name')){
                                    self.getUserRoles(this.$cookies.get('user_name'))
                                }else{
                                    self.$message({message: '获取不到userid', type: 'error'})
                                }
                                clearTimeout(self.useridTimer)
                            },500)


                        }).catch(err => {
                            // console.log(err);
                            this.loading = false;
                            this.$message({message: err.message, type: 'error'});
                        }).finally(() => {
                            this.loading = false
                            this.loginForm.verification_code=null
                            this.imgUrlEvent()
                        });
                    } else {
                        return false;
                    }

                })
            },
            getDifferentEncrypt(sq){
                let formword = this.loginForm.password
                // ssoService.getEncrypt({username:this.loginForm.username})
                ssoService[sq]({username:this.loginForm.username})
                .then((data) => {
                    const key = CryptoJS.enc.Utf8.parse(data.key);  //十六位密钥
                    const iv = CryptoJS.enc.Utf8.parse(data.iv);   //十六位密钥偏移量
                      let srcs = CryptoJS.enc.Utf8.parse(formword);
                      let encrypted = CryptoJS.AES.encrypt(srcs, key, {iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7});
                      this.cryptoPassword = encrypted.toString();
                      this.submitForm()
                })
                .catch((err) => {
                    console.log(err)
                    this.loading = false;
                    this.$message({message: err.message, type: 'error'});
                })
            },
            getCryptoJsEvent(){
                if(this.ind == 1){
                    this.getDifferentEncrypt('getEncrypt')
                }else{
                   this.getDifferentEncrypt('getThirdEncrypt')
                }

            },
            cancel () {
                this.loginForm = {}
            },
            handitemclick(title) {
                if (this.ind&&this.ind==1){
                    window.open('https://oadh.autoai.com/home/resetpwd')
                }else{
                    this.$emit('changetitle', title)
                }

            }
        }
    }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .routerLink /deep/ .el-button {
        font-size: 16px;
        float: right;
        color:#3A8DFC;
    }
    .loginForm {
        padding: 0 75px;
        box-sizing: border-box;
        /deep/ .el-form {
            margin: 50px 0 0;
            .el-form-item__label {
                font-size: 20px;
                text-align: center;
                width: 100px;
                padding-right: 0;
            }
            .el-form-item {
                &:nth-child(1) {
                    margin-bottom: 40px;
                }
                &:nth-child(3) {
                    margin-bottom: 10px !important;
                }
                font-size: 18px;
                .el-input--mini {
                    font-size: 18px;
                }
                .el-button {
                    span {
                        border-bottom: 1px solid #5689c5;
                    }
                }
            }
            .codeItem{
                margin-bottom: 0px !important;
            }
        }
    }
    .tipText{
        text-align: center;
        color:#c3c3c3;
        font-size: 12px;
        margin-bottom: 10px;
    }
    .thirdTipText{
        margin-left:10%;
        margin-bottom:15px;
        line-height: 30px;
    }
    .submintbtn {
        margin-top: 0px;
        text-align: center;
        /deep/ .el-button {
            width: 200px;
            height: 36px;
            font-size: 14px;
            margin-bottom: 20px;
        }
        display: flex;
        justify-content: space-between;
    }
</style>

